import { PureComponent } from 'react';
import cn from './styles.local.less';
import Icon360 from './svg/Icon360.com.svg';

export default class ThreeSixtyBadge extends PureComponent {
  render() {
    return (
      <div className={cn.root}>
        <Icon360 className={cn.icon360} />
      </div>
    );
  }
}
